import restCrudActions from '../../../np-crud/store/restCrudActions'
import { getAxiosInstance } from '../../../np-rest/rest';
import { snackActions } from '../../../sc-utilities/SnackBar';

// Create CRUD action creator
const crudActions = restCrudActions({
    endpointBasePath: 'products/unpairedProduct',
    pluginName: 'PRODUCT',
    entityName: 'UNPAIRED_PRODUCT',
    fetchSuccessMessage: '',
    loadSuccessMessage: ''
});

// Fetch unpairedProduct action creators
export const fetchUnpairedProductInit = () => {
    return crudActions.fetchInit();
};
export const fetchUnpairedProductStart = () => {
    return crudActions.fetchStart();
};
export const fetchUnpairedProductSuccess = () => {
    return crudActions.fetchSuccess();
};
export const fetchUnpairedProductFail = () => {
    return crudActions.fetchFail();
};
export const fetchUnpairedProductCount = (filterData, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchUnpairedProductStart());
        try {
            let countRes = await rest.post("products/unpairedProduct/count", filterData, { cancelToken: options.countSource.token });
            if (countRes.data && countRes.data.succeeded) {
                if (!countRes.data.result.data) {
                    dispatch(fetchUnpairedProductSuccess(0, []));
                }
                return { data: countRes.data.result.data }
            }
            if (countRes && countRes.canceled) {
                return { data: 0, canceled: true };
            }
            dispatch(fetchUnpairedProductFail());
            snackActions.snackBar({
                message: `${countRes && countRes.data ? countRes.data.message : "Cannot fetch unpaired product."}`,
                options: {
                    variant: 'warning'
                }
            });
            return { data: 0 };
        } catch (error) {
            dispatch(fetchUnpairedProductFail());
            snackActions.snackBar({
                message: `${error.message || "Cannot fetch unpaired product."}`,
                options: {
                    variant: 'error'
                }
            });
            return { data: 0 };
        }
    }
};



export const fetchUnpairedProduct = (filterData, options = {}) => {
    const rest = getAxiosInstance();
    return async dispatch => {
        dispatch(fetchUnpairedProductStart());
        try {
            let listRes = await rest.post("products/unpairedProduct/list", filterData, { cancelToken: options.listSource.token });
            if (listRes && listRes.canceled) {
                return { data: [], canceled: true };
            }
            if (listRes.data && listRes.data.succeeded) {
                dispatch(fetchUnpairedProductSuccess(filterData.count, listRes.data.result.data));
                return { data: listRes.data.result.data };
            }
            dispatch(fetchUnpairedProductFail());
            return { data: [] };
        }
        catch (error) {
            dispatch(fetchUnpairedProductFail());

            return { data: [] };
        }
    }
};

export const assignExternalID = data => {
    const rest = getAxiosInstance();
    return async dispatch => {
        try {
            let res = await rest.post('/products/unpairedProduct/assignExternalID', data);
            if (res.data && res.data.succeeded) {
                snackActions.snackBar({
                    message: `${res && res.data ? res.data.message : res && res.message ? res.message : "Cannot assign to existing product."}`,
                    options: {
                        variant: 'success'
                    }
                });
                return true;
            } else {
                snackActions.snackBar({
                    message: `${res.data ? res.data.message : res.message}`,
                    options: {
                        variant: 'warning'
                    }
                })
                return false;
            }
        } catch (error) {
            return false;
        }
    };
};

export const bulkForceCreate = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/products/unpairedProduct/bulkForceCreate', params);
            if (res.data && res.data.succeeded) {
                return true;
            }
            return false;
        } catch (error) {
            return false;
        }
    };
};

export const forceCreate = params => {
    const rest = getAxiosInstance();
    return async () => {
        try {
            let res = await rest.post('/products/unpairedProduct/forceCreate', params);
            if (res.data && res.data.succeeded) {
                return true;
            }
            return false;
        } catch (error) {
            return false;
        }
    };
};